import PropTypes from 'prop-types';
import React from 'react';

export default function LastEditedInformationColumn({ row }) {
  return (
    <div className="br-table-editor-last-edited-info-column">
      <div className="last-edited-at-content" title={row.Modified.value}>
        {row.Modified.value}
      </div>
      <div className="last-edited-by-content" title={row.User.value}>
        {row.User.value}
      </div>
    </div>
  );
}

LastEditedInformationColumn.defaultWidth = 180;

LastEditedInformationColumn.propTypes = {
  row: PropTypes.shape({
    // row data
    Modified: PropTypes.object,
    User: PropTypes.object,
  }).isRequired,
};
